import React, { useEffect } from 'react';
import { useLocation } from "react-router";
import { setAttributorFromUrl } from '../../utils/activityTracking';
import * as queryString from "query-string";

// Attributor component handles URL parameter campaign tracking
const Attributor = () => {
  const location = useLocation();

  useEffect(() => {
    const params = queryString.parse(location.search);

    let campaign = params.utm_campaign ? params.utm_campaign : '';
    if (campaign) {
      // between 01/08/23 to 18/12/25 we were also using sessionStorage to store attributor for iframe embedding
      setAttributorFromUrl(campaign);
    }
  }, [])


  return (
    <></>
  );
}

export default Attributor